//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Utils imports
import { QUERY_KEYS, queryInvalidator } from "@/utils/query-client";

//* Types imports
import type { ISaleInputDTO } from "@/schemas";

type UpdateSaleParams = {
  id: string;
  data: Partial<ISaleInputDTO>;
};

async function updateSale({ id, data }: UpdateSaleParams) {
  const response = await fetch(`${API_URL}/sales/${id}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Falha ao atualizar venda");
  }

  return response.json();
}

export function useUpdateSale() {
  return useMutation({
    mutationFn: updateSale,
    onSuccess: async (_, variables) => {
      await queryInvalidator([
        [QUERY_KEYS.SALES.ALL],
        [QUERY_KEYS.SALES.SINGLE, variables.id],
      ]);
      toast.success("Venda atualizada com sucesso!");
    },
  });
}
